import { render } from "./CandidatesCampList.vue?vue&type=template&id=4ff4449f"
import script from "./CandidatesCampList.vue?vue&type=script&lang=js"
export * from "./CandidatesCampList.vue?vue&type=script&lang=js"

import "./CandidatesCampList.vue?vue&type=style&index=0&id=4ff4449f&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__